import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { InstitutionService } from '@edtech-ui/core/services/admin-panel/institution.service';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';

@Component({
	selector: 'app-institution-management',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatButtonModule,
		MatIconModule,
		MatCardModule,AdminHeaderComponent
	],
	templateUrl: './institution-management.component.html',
	styleUrl: './institution-management.component.scss'
})
export class InstitutionManagementComponent implements OnInit {
	institutionForm!: FormGroup;
	tenantName='Institution Details';
	tenantSubName='Manage your institution information and subscription';

	constructor(private fb: FormBuilder, private institutionService: InstitutionService) { }

	ngOnInit() {
		this.institutionForm = this.fb.group({
			name: [''],
			domain: [''],
			type: [''],
			format: [''],
			email: [''],
			address: ['']
		});

		this.loadInstitutionData();
	}

	loadInstitutionData() {
		this.institutionService.getInstitutionDetails().subscribe(data => {
			this.institutionForm.patchValue(data);
		});
	}

	saveChanges() {
		this.institutionService.updateInstitution(this.institutionForm.value).subscribe();
	}



}
